import { actions, reducer } from "./ducks";
import page from "./_TeamAndStaffPage/_TeamAndStaffPage";
import { Feature } from "features/interfaces";
import saga from "./saga";

export const teamAndStaffFeature: Feature<typeof actions> = {
  reducer,
  saga,
  actions,
  page
};
